import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Content, Root } from './Tooltip.styles'

/**
 * The Tooltip' component.
 */
const Tooltip = forwardRef((props, ref) => {
  const { children, content, placement, variant, ...restProps } = props

  return (
    <Root
      {...restProps}
      arrow={variant !== 'title'}
      placement={variant === 'title' ? 'top-end' : placement}
      ref={ref}
      title={
        <Content tabindex="0" variant={variant}>
          {content}
        </Content>
      }
      variant={variant}
    >
      {children}
    </Root>
  )
})

Tooltip.defaultProps = {
  content: '',
  placement: 'right',
  variant: 'default'
}

Tooltip.propTypes = {
  /**
   * Children.
   */
  children: PropTypes.node.isRequired,
  /**
   * Content.
   */
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /**
   * Placement.
   */
  placement: PropTypes.oneOf([
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top'
  ]),
  /**
   * Variant.
   */
  variant: PropTypes.oneOf(['default', 'title'])
}

export default Tooltip
